import React from "react";
import { Modal } from "antd";
import { ApartmentOutlined } from "@ant-design/icons";
import PlanHierarchyManager from "../PlanHierarchyManager";

function PlanHierarchyModal({ visible, onCancel, planId, planTitle, onHierarchyChange }) {
  return (
    <Modal
      title={
        <div className="flex items-center space-x-2">
          <ApartmentOutlined className="text-blue-500" />
          <span>Plan Hierarchy Management</span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
      destroyOnClose
    >
      <div className="space-y-4">
        {planTitle && (
          <div className="bg-blue-50 p-3 rounded-lg">
            <p className="text-sm text-blue-700">
              <strong>Managing hierarchy for:</strong> {planTitle}
            </p>
          </div>
        )}
        
        <PlanHierarchyManager
          planId={planId}
          onHierarchyChange={onHierarchyChange}
        />
      </div>
    </Modal>
  );
}

export default PlanHierarchyModal; 